import styles from './style.module.css';
import {useAtomValue} from 'jotai';
import {useRouter} from '@/hooks/useAppRouter';
import {userAtom} from '@/store/user';
import {UserSection} from '@/components/layout/user-section';
import {SvgIcon} from '@/components/ui/svg-icon';
import {ValueSkeleton} from '@/components/skeleton/value';
export function Header() {
    const user = useAtomValue(userAtom);
    const branding = user?.branding;
    const router = useRouter();

    const customLogoUrl =
        branding?.settings?.light_logo_image?.url ?? branding?.logo_image;

    function handleLogoClick() {
        router.push('/');
    }

    return (
        <header className={styles.header}>
            <div className={styles.logoContent}>
                <div
                    onClick={handleLogoClick}
                    className={
                        customLogoUrl
                            ? styles.headerLogoCustom
                            : styles.headerLogo
                    }
                >
                    {!user ? (
                        <div className={styles.svgLogo}>
                            <ValueSkeleton
                                value={undefined}
                                isLoading={true}
                                width={150}
                                height={30}
                            />
                        </div>
                    ) : customLogoUrl ? (
                        <img
                            className={styles.customLogo}
                            src={customLogoUrl}
                            alt={
                                branding?.name
                                    ? `${branding.name} Logo`
                                    : 'Custom Logo'
                            }
                        />
                    ) : (
                        <div className={styles.svgLogo}>
                            <SvgIcon
                                name="logo"
                                className={styles.logoIcon}
                                title="Floorplanner Logo"
                            />
                        </div>
                    )}
                </div>
                <div className={styles.logoText}>Modelbank</div>
            </div>
            <UserSection />
        </header>
    );
}
